import React from 'react'
import AsyncSelect from 'react-select/async'
import CreatableSelect from 'react-select/creatable'
import debounce from 'debounce-promise'
import Select, { components } from 'react-select'

const AsyncControl = (props) => (
  <components.Control {...props} className="border border-gray-400 px-4 py-3" />
)

const Control = (props) => (
  <components.Control {...props} className="border border-gray-400 px-4 py-3" />
)

export const NextAsyncSelect = ({ isValid = true, promise, ...props }) => {
  const loadOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      promise(query)
        .then((result) => resolve(result))
        .catch(reject)
    })
  }, 250)

  return (
    <AsyncSelect
      components={{ Control: AsyncControl }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          neutral20: isValid ? '#cbd5e0' : '#dc2626', // text-gray-400 or text-red-400
          neutral30: '#718096', // text-gray-600
        },
      })}
      isMulti
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      openMenuOnFocus
      loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
      {...props}
    />
  )
}


export const NextSelect = (props) => (
  <Select
    components={{ Control }}
    styles={{
      placeholder: (base) => ({ ...base, color: '#9eaebf', fontSize: '0.875rem' }),
      singleValue: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
      valueContainer: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
    }}
    theme={(theme) => ({
      ...theme,
      borderRadius: 0,
      colors: {
        ...theme.colors,
        neutral20: '#cbd5e0', // text-gray-400
        neutral30: '#718096', // text-gray-600
      },
    })}
    {...props}
  />
)

export const NextCreatableSelect = (props) => (
  <CreatableSelect
    components={{ Control }}
    styles={{
      placeholder: (base) => ({ ...base, color: '#9eaebf', fontSize: '0.875rem' }),
      singleValue: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
      valueContainer: (base) => ({ ...base, color: '#1a202c', fontSize: '0.875rem' }),
    }}
    theme={(theme) => ({
      ...theme,
      borderRadius: 0,
      colors: {
        ...theme.colors,
        neutral20: '#cbd5e0', // text-gray-400
        neutral30: '#718096', // text-gray-600
      },
    })}
    {...props}
  />
)

export {
  NextAsyncSelect as AsyncSelect,
  NextSelect as Select,
  NextCreatableSelect as CreatableSelect,
}
